import React, {
  useEffect,
  useState
} from 'react'
import { ProductOption } from '@/modules/product/types/product'
import ChronoTextInput from '@/layouts/core/components/ChronoTextInput'
import { CartItem } from '@/modules/cart/types/cart'
import ChronoSelect from '@/layouts/core/components/ChronoSelect'
import {
  removeFromCart,
  updateCartQuantity
} from '@/modules/cart/cartSlice'
import { useDispatch } from 'react-redux'
import { createLogger } from '@/common/logger'

const MAX_QUANTITY = 10

const logger = createLogger({ prefix: 'CartItemQuantity' })

function createRange (size) {
  // @ts-ignore
  return [...Array(size).keys()]
}

type CartItemQuantityProps = {
  fullWidth?: boolean
  autoUpdate?: boolean
  onUpdate?: (number) => void
  asSelect?: boolean
} & CartItem

const CartItemQuantity = (props: CartItemQuantityProps) => {
  const { product, option, shippingType, quantity, autoUpdate } = props
  const dispatch = useDispatch()
  const [max, setMax] = useState<number>(MAX_QUANTITY)
  const maxToUser = product.maxItemsPerPerson
  const { remaining } = option

  const onUpdateCartQuantity = (newQuantity) => {
    if (autoUpdate && newQuantity == 0) {
      dispatch(removeFromCart({
        product,
        option,
        shippingType,
        quantity
      }))
    } else if (autoUpdate) {
      dispatch(updateCartQuantity({
        product,
        option,
        shippingType,
        quantity: newQuantity
      }))
    }
    props.onUpdate && props.onUpdate(newQuantity)
  }

  useEffect(() => {
    const computeMax = () => {
      let tempMax

      if (remaining === 0) {
        tempMax = Math.max(quantity, 0)
      } else if (maxToUser && maxToUser < remaining) {
        tempMax = maxToUser
      } else {
        tempMax = Math.max(remaining, quantity)
      }
      return Math.min(tempMax, MAX_QUANTITY)
    }

    logger.log('onUpdate: ', { quantity, option, maxToUser, remaining })

    const tempMax = computeMax()
    setMax(tempMax)
  }, [maxToUser, option, remaining, quantity])

  if (props.asSelect !== false) {
    return (
      <ChronoSelect
        name={'quantity'}
        label={'Qty'}
        fullWidth={props.fullWidth}
        defaultValue={quantity}
        sx={{
          minWidth: 50
        }}
        options={createRange(max).map(num => ({
          name: num + 1,
          value: num + 1
        }))}
        onUpdate={(qty) => {
          onUpdateCartQuantity(parseInt(qty))
        }}
      />
    )
  }

  return (
    <ChronoTextInput
      name={'quantity'}
      label={'Qty'}
      type={'number'}
      defaultValue={quantity}
      inputProps={{
        min: 1,
        max
      }}
      sx={{
        minWidth: 50
      }}
      onUpdate={(qty) => {
        onUpdateCartQuantity(parseInt(qty))
      }}
    />
  )
}
export default CartItemQuantity